var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInpecstion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 4.2a.667.667 0 000 .933L9.867 6.2a.667.667 0 00.933 0l2.513-2.513A3.999 3.999 0 018.02 8.98l-4.607 4.607a1.414 1.414 0 01-2-2L6.02 6.98a4 4 0 015.293-5.293L8.807 4.193 8.8 4.2z",
    stroke: "#e95832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/inpecstion.dccbf23f.svg";
export { SvgInpecstion as ReactComponent };